export const SET_SESSION_USER = 'SET_SESSION_USER';
export const SET_USER_PERMISSIONS = 'SET_USER_PERMISSIONS';
export const UPDATE_SESSION_USER_IMAGE = 'UPDATE_SESSION_USER_IMAGE';
export const MULTIPLE_ACCOUNTS = 'MULTIPLE_ACCOUNTS';
export const CLEAR_MULTIPLE_ACCOUNTS = 'CLEAR_MULTIPLE_ACCOUNTS';
export const SET_CURRENT_COMPANY = 'SET_CURRENT_COMPANY';
export const UPDATE_COMPANY_IMAGE = 'UPDATE_COMPANY_IMAGE';
export const LOGGED_OUT = 'LOGGED_OUT';
export const REDIRECT_SET = 'REDIRECT_SET';
export const UPDATE_SESSION_USER_ATTR = 'UPDATE_SESSION_USER_ATTR';
export const LOGIN_LOADING = 'LOGIN_LOADING';
export const LOGIN_NOT_LOADING = 'MULTI_LOGIN_NOT_LOADING';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILED = 'LOGIN_FAILED';
export const MULTI_LOGIN_LOADING = 'MULTI_LOGIN_LOADING';
export const MULTI_LOGIN_NOT_LOADING = 'LOGIN_NOT_LOADING';
export const ACCOUNT_SUSPENDED = 'ACCOUNT_SUSPENDED';
export const SUSPENDED_MESSAGE_DISPLAYED = 'SUSPENDED_MESSAGE_DISPLAYED';

export enum SignupCompany {
  Request = 'COMPANY_SIGNUP_REQUEST',
  Success = 'COMPANY_SIGNUP_SUCCESS',
  Failed = 'COMPANY_SIGNUP_FAILED',
}

export enum PatchSessionUser {
  Request = 'PATCH_SESSION_USER_REQUEST',
  Success = 'PATCH_SESSION_USER_SUCCESS',
  Failed = 'PATCH_SESSION_USER_FAILED',
}

export enum ChangePassword {
  Request = 'CHANGE_PASSWORD_REQUEST',
  Success = 'CHANGE_PASSWORD_SUCCESS',
  Failed = 'CHANGE_PASSWORD_FAILED',
}

export enum UpdateSessionUserAttrs {
  Request = 'UPDATE_SESSION_USER_ATTRS_REQUEST',
  Success = 'UPDATE_SESSION_USER_ATTRS_SUCCESS',
  Failed = 'UPDATE_SESSION_USER_ATTRS_FAILED',
}

export enum UpdateCompany {
  Request = 'UPDATE_COMPANY_REQUEST',
  Success = 'UPDATE_COMPANY_SUCCESS',
  Failed = 'UPDATE_COMPANY_FAILED',
}

export enum UpdateCompanyAttrs {
  Request = 'UPDATE_COMPANY_ATTRS_REQUEST',
  Success = 'UPDATE_COMPANY_ATTRS_SUCCCESS',
  Failed = 'UPDATE_COMPANY_ATTRS_FAILED',
}

export enum GetTimeZones {
  Request = 'GET_TIMEZONES_REQUEST',
  Success = 'GET_TIMEZONES_SUCCESS',
  Failed = 'GET_TIMEZONES_FAILED',
}

export enum GetLocales {
  Request = 'GET_LOCALES_REQUEST',
  Success = 'GET_LOCALES_SUCCESS',
  Failed = 'GET_LOCALES_FAILED',
}
